import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const Platform = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Platform", "terms/platform_body_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.Platform || { Main: {} };
  return (
    <div className="container py-5 text-start" style={{ lineHeight: "1.8em" }}>
      <h2 className="mb-4">{LANGUAGE.Main.Content1}</h2>

      <h4>{LANGUAGE.Main.Content2}</h4>
      <p>{LANGUAGE.Main.Content3}</p>
      <p>{LANGUAGE.Main.Content4}</p>

      <h4>{LANGUAGE.Main.Content5}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content6}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content7}</li>
            <li>{LANGUAGE.Main.Content8}</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content9}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content10}</li>
            <li>{LANGUAGE.Main.Content11}</li>
            <li>{LANGUAGE.Main.Content12}</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content13}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content14}</li>
            <li>{LANGUAGE.Main.Content15}</li>
          </ul>
        </li>
      </ul>


      <h4>{LANGUAGE.Main.Content16}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content17}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content18}</li>
            <li>{LANGUAGE.Main.Content19}</li>
          </ul>
        </li>
      </ul>

      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content20}</strong>
          <p>{LANGUAGE.Main.Content21}</p>
          <ul>
            <li>{LANGUAGE.Main.Content22}</li>
            <li>{LANGUAGE.Main.Content23}</li>
            <li>{LANGUAGE.Main.Content24}</li>
            <li>{LANGUAGE.Main.Content25}</li>
          </ul>
        </li>
      </ul>



      <h4>{LANGUAGE.Main.Content26}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content27}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content28}</li>
            <li>{LANGUAGE.Main.Content29}</li>
            <li>{LANGUAGE.Main.Content30}</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content31}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content32}</li>
            <li>{LANGUAGE.Main.Content33}</li>
          </ul>
        </li>
      </ul>



      <h4>{LANGUAGE.Main.Content34}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content35}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content36}</li>
            <li>{LANGUAGE.Main.Content37}</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content38}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content39}</li>
            <li>{LANGUAGE.Main.Content40}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content41}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content42}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content43}</li>
            <li>{LANGUAGE.Main.Content44}</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content45}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content46}</li>
            <li>{LANGUAGE.Main.Content47}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content48}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content49}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content50}</li>
            <li>{LANGUAGE.Main.Content51}</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content52}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content53}</li>
            <li>{LANGUAGE.Main.Content54}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content55}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content56}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content57}</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content58}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content59}</li>
            <li>{LANGUAGE.Main.Content60}</li>
          </ul>
        </li>
      </ul>


      <hr className="my-4" />

      <h5>{LANGUAGE.Main.Content61}</h5>
      <p>
        <strong>{LANGUAGE.Main.Content62}</strong> {LANGUAGE.Main.Content63}
        <br />
        <strong>{LANGUAGE.Main.Content64}</strong>{" "}
        <a href={`mailto:${LANGUAGE.Main.Content65}`}>{LANGUAGE.Main.Content65}</a>
        <br />
        <strong>{LANGUAGE.Main.Content66}</strong>{" "}
        <a
          href={LANGUAGE.Main.Content67}
          target="_blank"
          rel="noopener noreferrer"
        >
          {LANGUAGE.Main.Content67}
        </a>
      </p>
    </div>
  );
};

export default Platform;
